import { Globe } from "lucide-react";
import { useAuth } from "@/auth/auth-context";
import { api } from "@/lib/api/services";
import { useT } from "@/lib/i18n";
import { isSiteLanguage, setLanguage, SITE_LANGUAGES, useLanguage } from "@/lib/language";

/** Compact language picker: applies instantly on this device and, when signed in, saves it to the account too. */
export function LanguageSelect() {
  const t = useT();
  const language = useLanguage();
  const auth = useAuth();

  function change(value: string) {
    if (!isSiteLanguage(value) || value === language) return;
    setLanguage(value);
    // Best effort: the device choice already applies; the account setting only affects other devices and emails.
    if (auth.status === "authenticated") void api.setLanguage(value).catch(() => undefined);
  }

  return (
    <label className="language-select">
      <Globe size={14} aria-hidden="true" />
      <span className="sr-only">{t("common.language")}</span>
      <select value={language} onChange={(event) => change(event.target.value)}>
        {SITE_LANGUAGES.map((item) => <option key={item.id} value={item.id} lang={item.locale}>{item.label}</option>)}
      </select>
    </label>
  );
}
